import React from 'react';

import StatusSummaryButton from '../../../status/statusSummaryButton.jsx';

const AgreementRejectedSummary = () => (
    <StatusSummaryButton href="/avslatt-avtale">
        Du har avslått avtalen
    </StatusSummaryButton>
);

export default AgreementRejectedSummary;



// WEBPACK FOOTER //
// ./safeTrade/seller/agreement/summaries/agreementRejectedSummary.jsx